import {isArray,merge} from "lodash";
import {tryTransformIfEval} from "@/utils/commonUtils"
import JsonLayout from '@/components/vue-json-layout/vue-json-layout.vue'
import Vue from 'vue'

export const simpleValueView = (modelPath,path,titleProp="label",dateTimeFormat="",evalExpression,evalExpressionFormat='')=>{
  return {
    "component":"simple-value-view",
    "data":{
      "context":{
        "e":"{vue.$lodash.get(vue,'"+modelPath+"')}"
      }
    },
    "params":{
      "props":{
        "value":evalExpression?"{vue.$commonUtils.transformStrByEval('{"+evalExpression+"}',vue.data.context)}"
                    :"{vue.$lodash.get(vue."+modelPath+",'"+path+"')}",
        "dateTimeFormat":dateTimeFormat,
        "titleProp":titleProp,
        "durationFormat": evalExpression ? (evalExpressionFormat ? evalExpressionFormat : "h") : ""
      }
    }
  }
};

export const arrayListView = (modelPath,path,prop)=>{
  return {
    "component":"array-list-view",
    "params":{
      "props":{
        "value":"{vue.$lodash.get(vue."+modelPath+",'"+path+"')}",
        "prop":prop,
      }
    }
  }
};

export const dateIntervalView = (modelPath,minDatePath,maxDatePath,dateTimeFormat)=>{
  return {
    "component":"date-interval-view",
    "params":{
      "props":{
        "dateMin":"{vue.$lodash.get(vue."+modelPath+",'"+minDatePath+"')}",
        "dateMax":"{vue.$lodash.get(vue."+modelPath+",'"+maxDatePath+"')}",
        "dateTimeFormat":dateTimeFormat
      },
    }
  }
};

export const elDateTimePickerMinMaxControl = (modelPath,minDatePath,maxDatePath,minProp,maxProp)=>{
  return {
    "component":"el-date-time-picker-minmax-control",
    "params":{
      "props":{
        "propertyMin":minProp,
        "propertyMax":maxProp,
        "valueMin":"{vue.$lodash.get(vue."+modelPath+",'"+minDatePath+"')}",
        "valueMax":"{vue.$lodash.get(vue."+modelPath+",'"+maxDatePath+"')}",
      },
      "on":{
        "input":"{function(e){Vue.$nestedSet(vue."+modelPath+", '"+minDatePath+"', e[0]);Vue.$nestedSet(vue."+modelPath+", '"+maxDatePath+"', e[1])}}"
      }
    }
  }
};

export const inputControl = (modelPath,path,prop,options={})=>{
  return {
    "component": "input-control",
    "params": {
      "props": {
        "options": options,
        "property": prop,
        "value":"{vue.$lodash.get(vue."+modelPath+",'"+path+"')}"
      },
      "on": {
        "input":"{function(e){Vue.$nestedSet(vue."+modelPath+", '"+path+"', e)}}"
      },
    }
  }
};

export const checkBoxControl = (modelPath,path,prop,options={})=>{
  return {
    "component": "checkbox-control",
    "params": {
      "props": {
        "options": options,
        "property": prop,
        "value":"{vue.$lodash.get(vue."+modelPath+",'"+path+"')}"
      },
      "on": {
        "input":"{function(e){Vue.$nestedSet(vue."+modelPath+", '"+path+"', e)}}"
      },
    }
  }
};

export const textAreaControl = (modelPath,path,prop,options={})=>{
  return {
    "component": "text-area-control",
    "params": {
      "props": {
        "options": options,
        "property": prop,
        "value":"{vue.$lodash.get(vue."+modelPath+",'"+path+"')}"
      },
      "on": {
        "input":"{function(e){Vue.$nestedSet(vue."+modelPath+", '"+path+"', e)}}"
      },
    }
  }
};

export const selectControl = (modelPath,path,prop,options={})=>{
  return {
    "component": "select-control",
    "params": {
      "props": {
        "options": options,
        "property": prop,
        "value":"{vue.$lodash.get(vue."+modelPath+",'"+path+"')}"
      },
      "on": {
        "input":"{function(e){Vue.$nestedSet(vue."+modelPath+", '"+path+"', e)}}"
      },
    }
  }
};

export const dropdownHttpControl = (modelPath,path,httpSchemas,isMulti,hideSearch=false)=>{
  return {
    "component":"dropdown-http-control",
    "params":{
      "props":{
        "url":isArray(httpSchemas)?httpSchemas[0].url:httpSchemas,//TODO переделать под каскад
        "value": "{vue.$lodash.get(vue."+modelPath+",'"+path+"')"+(isMulti?"||[]":"||null")+"}",
        hideSearch
      },
      "on": {
        "input":"{function(e){Vue.$nestedSet(vue."+modelPath+", '"+path+"', e)}}"
      },
    },
    "children":[]
  }
};

//Работает только для jsonLayout2
export const editEntityBySchemaButton = (modelPath,hyperSchema,editEntityDialogOptions)=>{
  return {
    "component":"div",
    "data":{
      "editiongEntity":null
    },
    "params":{
      "class":"ui mini icon button",
      "style":{"background":"none"},
      "on":{
        "click":"{function(e){vue.data.editiongEntity=Vue.$lodash.cloneDeep(vue."+modelPath+")}}"
      }
    },
    "children":[
      {
        "component":"i",
        "params":{"class":"icon edit"}
      },
      {
        "component":"schema-dialog",
        "vIf": "{vue.data.editiongEntity&&vue.data.editiongEntity.id==vue."+modelPath+".id}",
        "params":{
          "props": {
            "initModel":"{vue.data.editiongEntity}",
            "hyperSchema":hyperSchema,
            "dialogOption":editEntityDialogOptions,
            "actionLink":"update"
          },
          "on": {
            "apply": "{function(e){vue.data.editiongEntity=null}}",
            "cancel": "{function(e){vue.data.editiongEntity=null}}"
          }
        }
      }
    ]
  }
};

export const createEntityBySchemaDialog = (hyperSchema,layoutOption={},options={},initModel={},cancelHandler=()=>{})=>{
  return {
    "component": "schema-dialog",
    "params": {
      "props": {
        "initModel": initModel,
        "hyperSchema": hyperSchema,
        "dialogOption": options,
        "layoutOption":layoutOption,
        "actionLink": "create"
      },
      "on": {
        "apply": applyHandler,
        "cancel": cancelHandler
      }
    }
  }
};

const JsonLayoutClass = Vue.extend(JsonLayout);
export const mountEntityBySchemaDialog = (hyperSchema,layoutOption={},options={},initModel={},applyHandler=()=>{},cancelHandler=()=>{})=>{
  let jsonLayout;
  const dialogLayout = {
    "component": "schema-dialog",
    "params": {
      "props": {
        "initModel": initModel,
        "hyperSchema": hyperSchema,
        "dialogOption": options,
        "layoutOption":layoutOption,
        "actionLink": "create"
      },
      "on": {
        "apply": ()=>{jsonLayout.$destroy(true);jsonLayout.$el.remove()},
        "cancel": ()=>{jsonLayout.$destroy(true);jsonLayout.$el.remove()},
      }
    }
  };
  jsonLayout = new JsonLayoutClass({propsData: {layout: dialogLayout, model: {}}});
  //merge(dialogLayout,{"params":{"on":{"apply":}}})
  jsonLayout.$mount();
  document.body.appendChild(jsonLayout.$el)


};


export const mountComponentIn = (layout,parentElement=document)=>{
  const jsonLayout = new JsonLayoutClass({propsData: {layout: layout, model: {}}});
  jsonLayout.$mount();
  parentElement.documentElement.appendChild(jsonLayout.$el);
  return jsonLayout;
};
